import React, { useState, useEffect } from "react";
import { useDarkMode } from "context/DarkModeProvider";

const ProfileLayout = ({ children }) => {

    const { darkMode } = useDarkMode();

    return (
        <div
            style={{
                height: "100%",
                width: "100%",
                display: "flex",
                padding: "20px 10px 10px 10px",

            }}
        >
            {children}
        </div>
    );
};

export default ProfileLayout;